// RootContext.ts
import { Accessor, createContext, createSignal, useContext } from "solid-js";

export type NavbarContextValue = {
  title: Accessor<string>;
  setTitle: (title: string) => void;
};

const NavbarContext = createContext<NavbarContextValue>();

export function NavbarProvider(props: { children: any }) {
  const [title, setTitle] = createSignal("Hjem");

  return (
    <NavbarContext.Provider value={{ title: title, setTitle }}>
      {props.children}
    </NavbarContext.Provider>
  );
}

export function useNavbar() {
  const ctx = useContext(NavbarContext);
  if (!ctx) throw new Error("useNavbar must be used within NavbarProvider");
  return ctx;
}
